<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentEditMember /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentEditMember from '@/components/worker/dashboard/modules/users/member/ContentEditMember.vue'

export default 
{
  name: 'EditMember',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentEditMember
  }
}
</script>
<style>


</style>